import { render, staticRenderFns } from "./DocView.vue?vue&type=template&id=11aea6c4"
import script from "./DocView.vue?vue&type=script&lang=js"
export * from "./DocView.vue?vue&type=script&lang=js"
import style0 from "./DocView.vue?vue&type=style&index=0&id=11aea6c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports